import StateComponent from '../../../StateComponent'
import _ from "underscore"
import {connect} from '../../../redux/utils'
import {getOldPasswordSettings, getRawSettings, isPasswordRulesGotStronger} from '../selectors'
import {setStrongerFlag} from '../actions'

function isStronger(oldSettings, newSettings) {
    return _.difference(newSettings.ruleIds, oldSettings.ruleIds).length > 0
           || (newSettings.minimalLength > oldSettings.minimalLength)
}

export default class PasswordStrongStatusChecker extends StateComponent {

    constructor({
        oldSettings = {},
        newSettings = oldSettings,
        newIsStronger = false,
        onGettingStronger = () => {}
    } = {}) {
        super({oldSettings, newSettings, newIsStronger});
        this.onStatePropertyChanged("newSettings", () => {
            let newSettingsBecameStronger = isStronger(this.state.oldSettings, this.state.newSettings)
            if (this.state.newIsStronger !== newSettingsBecameStronger)
                onGettingStronger(newSettingsBecameStronger)
        })
    }

    init() {}
}

export const Connected = connect(state => ({
    oldSettings: getOldPasswordSettings(state),
    newSettings: getRawSettings(state),
    newIsStronger: isPasswordRulesGotStronger(state)
}), dispatch => ({
    onGettingStronger: (stronger) => dispatch(setStrongerFlag(stronger))
}))(PasswordStrongStatusChecker)



// WEBPACK FOOTER //
// ./web/js/administration/passwordSettings/components/PasswordStrongStatusChecker.js